// RFC 5321 printable characters allowed in the local part of an email address.
// Excludes control characters and characters that require quoting.
const LOCAL_PART_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/;

interface IEmailValidationResult {
  isValid: boolean;
  error?: string;
}

const validateEmail = (email: string): IEmailValidationResult => {
  const trimmed = email.trim();

  if (trimmed.length === 0) {
    return { isValid: false, error: 'Please enter your email address.' };
  }

  if (/\s/.test(trimmed)) {
    return { isValid: false, error: 'Email addresses cannot contain spaces.' };
  }

  if (trimmed.length > 254) {
    return { isValid: false, error: 'Please enter a valid email address.' };
  }

  const atParts = trimmed.split('@');
  if (atParts.length !== 2) {
    return { isValid: false, error: 'Please enter a valid email address.' };
  }

  const [local, domain] = atParts;

  if (local.length === 0 || local.length > 64) {
    return { isValid: false, error: 'Please enter a valid email address.' };
  }

  if (!LOCAL_PART_REGEX.test(local)) {
    return { isValid: false, error: 'Please enter a valid email address.' };
  }

  // Domain must have at least one dot with a character on each side
  if (!/^[^.]+(\.[^.]+)+$/.test(domain)) {
    return { isValid: false, error: 'Please enter a valid email address.' };
  }

  return { isValid: true };
};

export default validateEmail;

export type { IEmailValidationResult };
